import { HttpInterceptorFn, HttpResponse, HttpErrorResponse, HttpContextToken } from '@angular/common/http';
import { inject } from '@angular/core';
import { map, catchError, throwError, finalize } from 'rxjs';
import { LoaderService } from '../services/loader.service';

export const SKIP_LOADER = new HttpContextToken<boolean>(() => false);

export const responseInterceptor: HttpInterceptorFn = (req, next) => {
  const loader = inject(LoaderService);
  // GET requests already have a local page-level spinner in every feature component,
  // so the global overlay only needs to cover writes (which rely on it for feedback).
  const skipLoader = req.context.get(SKIP_LOADER) || req.method === 'GET';
  if (!skipLoader) loader.start();

  return next(req).pipe(
    map((event) => {
      if (event instanceof HttpResponse) {
        const body = event.body as { success?: boolean; data?: unknown };
        if (body && body.success === true && 'data' in body) {
          return event.clone({ body: body.data });
        }
      }
      return event;
    }),
    catchError((err: HttpErrorResponse) => {
      if (err.error && err.error.success === false) {
        return throwError(
          () =>
            new HttpErrorResponse({
              error: err.error.error ?? 'An error occurred',
              status: err.status,
              statusText: err.statusText,
              url: err.url ?? undefined,
              headers: err.headers,
            })
        );
      }
      return throwError(() => err);
    }),
    finalize(() => { if (!skipLoader) loader.stop(); }),
  );
};
